<div
  class="view-batch"
  [ngClass]="{ 'view-batch__full': isFullScreen$ | async }"
>
  @if (batch(); as batch) {
    @if (!isBatchLoading()) {
      <header class="view-batch__header">
        <section class="view-batch__header-manage">
          @if (batch.has_documents_label) {
            <div class="view-batch__header-manage-button">
              <button
                type="button"
                class="button button--outlined button--sm d-flex align-items-center download-all-button"
                [disabled]="isDownloadAllLabelsDisabled()"
                (click)="formAllLabels()"
              >
                @if (
                  loadingAllLabelsRequestState() ===
                  BatchDocumentStatus.PROCESSING
                ) {
                  <div class="spinner text-center mr-2">
                    <div class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">{{ 'LOADING' | translate }}</span>
                    </div>
                  </div>
                } @else {
                  <span
                    class="mr-2"
                    [inlineSVG]="'assets/icons/download-batch-labels.svg'"
                  ></span>
                }

                {{
                  'BATCH_MAILING.BATCHES_TAB.DOWNLOAD_ALL_LABELS' | translate
                }}
              </button>
              @if (
                loadingAllLabelsRequestState() === BatchDocumentStatus.ERROR
              ) {
                <span class="download-error">{{
                  'BATCH_MAILING.BATCHES_TAB.LABEL_FORM_ERROR' | translate
                }}</span>
              }
            </div>
          }
        </section>

        <div class="view-batch__header-aside">
          <div class="view-batch__label-size-select">
            <label for="label-size">
              {{ 'BATCH_MAILING.BATCHES_TAB.LABEL_SIZE' | translate }}
            </label>
            <ng-select
              [placeholder]="labelSizePlaceholder"
              [clearable]="false"
              [items]="availableLabelSizes()"
              [searchable]="false"
              bindLabel="label"
              bindValue="value"
              id="label-size"
              [formControl]="labelSizeControl"
              labelForId="label-size"
            />
          </div>

          <div
            #actionMenu="bs-dropdown"
            dropdown
            container="body"
            class="view-batch__header-menu"
            [insideClick]="true"
          >
            <button
              id="button-action-menu"
              dropdownToggle
              type="button"
              class="view-batch__menu-trigger"
              [attr.aria-label]="'MENU_OPEN' | translate"
            >
              <span
                class="view-batch__menu-trigger-icon"
                [inlineSVG]="'assets/icons/ellipsis-vertical.svg'"
              ></span>
            </button>
            <ul
              *dropdownMenu
              id="dropdown-action-menu"
              role="menu"
              class="dropdown-menu dropdown-menu-right view-batch__dropdown-menu"
              aria-labelledby="button-action-menu"
            >
              <li role="menuitem">
                <a
                  class="filter-button azure"
                  type="button"
                  (click)="toggleFullScreen()"
                >
                  <span
                    class="filter-button-icon fullscreen-btn"
                    [inlineSVG]="
                      '../assets/img/icons/fullscreen-' +
                      ((isFullScreen$ | async) ? 'off' : 'on') +
                      '.svg'
                    "
                  ></span>
                  <span>
                    {{
                      ((isFullScreen$ | async)
                        ? 'FULLSCREEN_OFF'
                        : 'FULLSCREEN_TOOLTIP'
                      ) | translate
                    }}
                  </span>
                </a>
              </li>
              <li role="menuitem">
                <div dropdown>
                  <button
                    id="button-duplicate"
                    dropdownToggle
                    class="filter-button"
                    type="button"
                  >
                    <span [inlineSVG]="'assets/img/icons/duplicate.svg'"></span>
                    <span>
                      {{ 'BATCH_MAILING.BATCHES_TAB.DUPLICATE' | translate }}
                    </span>
                  </button>

                  <ul
                    id="dropdown-duplicate"
                    *dropdownMenu
                    class="dropdown-menu duplicate-dropdown-menu view-batch__dropdown-menu"
                    role="menu"
                    aria-labelledby="button-duplicate"
                  >
                    <li role="menuitem">
                      <button
                        type="button"
                        (click)="duplicate('duplicate-full')"
                        class="dropdown-item"
                      >
                        {{
                          'BATCH_MAILING.BATCHES_TAB.DUPLICATE_FULL' | translate
                        }}
                      </button>
                    </li>

                    <li role="menuitem">
                      <button
                        type="button"
                        (click)="duplicate('duplicate')"
                        class="dropdown-item"
                      >
                        {{
                          'BATCH_MAILING.BATCHES_TAB.DUPLICATE_PARTIAL'
                            | translate
                        }}
                      </button>
                    </li>
                  </ul>
                </div>
              </li>
              <li role="menuitem">
                <button
                  class="filter-button red"
                  type="button"
                  [disabled]="batch.status === BatchStatusEnum.IN_OPS"
                  (click)="removeBatch()"
                >
                  <fa-icon class="filter-button-icon red" [icon]="faTrashAlt">
                  </fa-icon>
                  <span class="red">{{ 'DELETE' | translate }}</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </header>

      @if (availableLabelSizes().length === 0) {
        <app-service-unavailable-banner />
      }

      <main class="view-batch__main">
        <article class="batch">
          <section class="batch-item">
            <p class="batch-item-title personal-item__default pointer">
              {{
                batch.name ||
                  ('BATCH_MAILING.BATCHES_TAB.BATCH' | translate) +
                    ' №' +
                    batch?.id
              }}
            </p>
            <p class="batch-item-text">
              @switch (batch.status) {
                @case (BatchStatusEnum.UNCOMMITED) {
                  {{
                    ('BATCH_MAILING.BATCHES_TAB.CREATED_AT' | translate) +
                      ': ' +
                      (dayjs(batch.created_at, 'YYYY-MM-DD HH:mm:ss').format(
                        'DD.MM.YYYY HH:mm:ss'
                      ) || '-')
                  }}
                }
                @case (BatchStatusEnum.COMMITED) {
                  {{
                    ('BATCH_MAILING.BATCHES_TAB.FORMATION_DATE' | translate) +
                      ': ' +
                      (dayjs(
                        batch.formation_date,
                        'YYYY-MM-DD HH:mm:ss'
                      ).format('DD.MM.YYYY HH:mm:ss') || '-')
                  }}
                }
                @case (BatchStatusEnum.IN_OPS) {
                  {{
                    ('BATCH_MAILING.BATCHES_TAB.UPDATED_AT' | translate) +
                      ': ' +
                      (dayjs(
                        batch.update_post_system_at,
                        'YYYY-MM-DD HH:mm:ss'
                      ).format('DD.MM.YYYY HH:mm:ss') || '-')
                  }}
                }
              }
            </p>
          </section>
          <div class="batch-item">
            <p class="batch-item-title">
              {{ batch.total_items }}
              {{ 'BATCH_MAILING.BATCHES_TAB.MAIL_ITEMS' | translate }}
            </p>
            <p class="batch-item-text">
              {{ 'BATCH_MAILING.BATCHES_TAB.BATCH_MAIL_COUNT' | translate }}
            </p>
          </div>
          <section class="batch-item">
            <p class="batch-item-title">
              {{ batch?.total_payable }}
              {{ 'BATCH_MAILING.BATCHES_TAB.RUB' | translate }}
            </p>
            <p class="batch-item-text">
              {{ 'BATCH_MAILING.BATCHES_TAB.POSTAL_DELIVERY_COST' | translate }}
            </p>
          </section>
          <section class="batch-item">
            <p class="batch-item-title">
              {{ batch.total_vat || 0 }}
              {{ 'BATCH_MAILING.BATCHES_TAB.RUB' | translate }}
            </p>
            <p class="batch-item-text">
              {{ 'BATCH_MAILING.BATCHES_TAB.INCLUDING_NDS' | translate }}
            </p>
          </section>
        </article>
        <article>
          <app-view-batch-tabs
            [activeTab]="activeTab"
            (setActiveTab)="setActiveTab($event)"
          >
          </app-view-batch-tabs>

          <app-view-batch-departures
            [batchDeparturesLoading$]="isBatchDeparturesLoading$"
            (sendDeletingDeparturesIds)="confirmDeleteDepartures($event)"
            [searchParam]="queryParams.search || ''"
            (batchDeparturesParamsChange)="onQueryParamsChange($event)"
            [session$]="session$"
            [batch]="batch"
            [activeTab]="activeTab"
          >
          </app-view-batch-departures>
        </article>
      </main>

      <footer class="view-batch__footer">
        <div class="button button&#45;&#45;outlined" (click)="back()">
          {{ 'BACK' | translate }}
        </div>

        @if (
          batch.status === BatchStatusEnum.UNCOMMITED &&
          (isCommitBtnShow$ | async)
        ) {
          <button
            class="button button&#45;&#45;filled button&#45;&#45; ml-3 d-flex"
            [disabled]="
              (isLoadingCommited$ | async) ||
              !batchDepartures()?.data.length ||
              availableLabelSizes().length === 0
            "
            (click)="commit()"
            type="button"
          >
            {{ 'BATCH_MAILING.BATCHES_TAB.FORM' | translate }}

            @if (isLoadingCommited$ | async) {
              <div class="spinner spinner&#45;&#45;alt text-center ml-2">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="sr-only">{{ 'LOADING' | translate }}</span>
                </div>
              </div>
            }
          </button>
        }
      </footer>
    } @else {
      <main class="text-secondary text-center">
        <div class="spinner-border spinner-border-lg" role="status">
          <span class="sr-only">{{ 'LOADING' | translate }}</span>
        </div>
      </main>
    }
  }
</div>
